export default __webpack_public_path__ + "static/LogoConductionWhite-922474ea7aa726cbfa9b6ffe0dca3ca7.svg";